/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * OIDC configuration for building authorization URLs (provider-agnostic)
 * @export
 * @interface OidcConfig
 */
export interface OidcConfig {
    /**
     * OIDC issuer URL (e.g., https://keycloak.example.com/realms/multi-tenant-saas or https://auth0.example.com)
     * @type {string}
     * @memberof OidcConfig
     */
    issuer?: string;
    /**
     * OAuth client ID
     * @type {string}
     * @memberof OidcConfig
     */
    clientId?: string;
    /**
     * Identity provider alias/hint for automatic redirect
     * @type {string}
     * @memberof OidcConfig
     */
    idpAlias?: string;
    /**
     * Provider-specific parameter name for identity provider hint (e.g., 'kc_idp_hint' for Keycloak, 'connection' for Auth0)
     * @type {string}
     * @memberof OidcConfig
     */
    idpHintParamName?: string;
    /**
     * Authorization endpoint path relative to issuer (optional, defaults to /protocol/openid-connect/auth)
     * @type {string}
     * @memberof OidcConfig
     */
    authorizationEndpointPath?: string;
    /**
     * Token endpoint path relative to issuer (optional, for token exchange)
     * @type {string}
     * @memberof OidcConfig
     */
    tokenEndpointPath?: string;
}

/**
 * Check if a given object implements the OidcConfig interface.
 */
export function instanceOfOidcConfig(value: object): value is OidcConfig {
    return true;
}

export function OidcConfigFromJSON(json: any): OidcConfig {
    return OidcConfigFromJSONTyped(json, false);
}

export function OidcConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): OidcConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'issuer': json['issuer'] == null ? undefined : json['issuer'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'idpAlias': json['idpAlias'] == null ? undefined : json['idpAlias'],
        'idpHintParamName': json['idpHintParamName'] == null ? undefined : json['idpHintParamName'],
        'authorizationEndpointPath': json['authorizationEndpointPath'] == null ? undefined : json['authorizationEndpointPath'],
        'tokenEndpointPath': json['tokenEndpointPath'] == null ? undefined : json['tokenEndpointPath'],
    };
}

export function OidcConfigToJSON(json: any): OidcConfig {
    return OidcConfigToJSONTyped(json, false);
}

export function OidcConfigToJSONTyped(value?: OidcConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'issuer': value['issuer'],
        'clientId': value['clientId'],
        'idpAlias': value['idpAlias'],
        'idpHintParamName': value['idpHintParamName'],
        'authorizationEndpointPath': value['authorizationEndpointPath'],
        'tokenEndpointPath': value['tokenEndpointPath'],
    };
}

